import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { ButtonModule } from 'primeng/button';
import { CalendarModule } from 'primeng/calendar';
import { InputTextModule } from 'primeng/inputtext';
import { TableModule } from 'primeng/table';
import { SharedModule } from 'src/app/shared/shared.module';
import { AuditComponent } from './audit.component';
import { AuditFiltersComponent } from './components/audit-filters.component';
import { AuditTableComponent } from './components/audit-table.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    InputTextModule,
    ReactiveFormsModule,
    AutoCompleteModule,
    ButtonModule,
    CalendarModule,
    TableModule,
    SharedModule
  ],
  declarations: [
    AuditComponent,
    AuditFiltersComponent,
    AuditTableComponent,
  ]
})
export class AuditModule { }
